import React, { useEffect } from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import EmployerFormsHeader from 'components/web-forms-list/EmployerFormsHeader';

import { useLazyQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import WebFormsTable, { EmployerFormInstance } from 'components/web-forms-list/WebFormsTable';
import { USER_ACTIONS } from 'types/enrollmentService';
import { GET_WEB_FORM_INSTANCES } from 'api/queries/formService';
import { createStyles } from '../../globalStyles';

const EmployerFormsPage = (): JSX.Element => {
  const classes = createStyles();

  const { periodId } = useParams<{ periodId: string }>();

  const [getWebFormInstances, { data, loading }] = useLazyQuery<{
    getWebFormInstances: EmployerFormInstance[];
  }>(GET_WEB_FORM_INSTANCES, {
    fetchPolicy: 'no-cache',
    variables: {
      enrollmentPeriodId: periodId,
    },
  });

  useEffect(() => {
    void getWebFormInstances();
  }, []);

  return (
    <ProposalStatusLayout>
      <div className={classes.pageWrapper}>
        <EmployerFormsHeader />
        <WebFormsTable
          formInstances={data?.getWebFormInstances || []}
          loading={loading}
          userAction={USER_ACTIONS.COMPLETE_WEB_FORMS}
          redirectLink="web-form"
        />
      </div>
    </ProposalStatusLayout>
  );
};

export default EmployerFormsPage;
